import { BaseEnum } from "./baseEnum";

const listJobTitleFamilyTypeEnum: Array<JobTitleFamilyTypeEnum> = [];

export type JobTitleFamilyType =
  | "None"
  | "Strategic"
  | "Operational"
  | "Tactical"
  | "Technical";

export class JobTitleFamilyTypeEnum extends BaseEnum {
  static None = new JobTitleFamilyTypeEnum(0, "None", "Nenhum", "minus");
  static Strategic = new JobTitleFamilyTypeEnum(1, "Strategic", "Estratégico", "target");
  static Operational = new JobTitleFamilyTypeEnum(2, "Operational", "Operacional", "cogs");
  static Tactical = new JobTitleFamilyTypeEnum(3, "Tactical", "Tático", "compass");
  static Technical = new JobTitleFamilyTypeEnum(4, "Technical", "Técnico", "tools");

  constructor(
    public id: number,
    public value: string,
    public label: string,
    icon: string
  ) {
    super(id, value, label, icon);
    listJobTitleFamilyTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listJobTitleFamilyTypeEnum;
  }
}